import React from 'react';
import classNames from 'classnames';

import './Tile.scss';

const Tile = ({ title, size, active, icon, onClick }) => (
  <button
    type="button"
    className={classNames('tile', {
      'tile--active': active,
      [`tile--${size}`]: size,
    })}
    onClick={onClick}
  >
    <div className="tile__icon">{icon}</div>
    <div className="tile__title">{title}</div>
  </button>
);

export default Tile;
